export const environment = {
  production: true,
  buildId: '3147279450920791',
  configFile: 'config.json',
};
